const GET_CENTER_GALLERY_INFORMATION_REQUEST = 'GET_CENTER_GALLERY_INFORMATION_REQUEST';
const GET_CENTER_GALLERY_INFORMATION_SUCCESS = 'GET_CENTER_GALLERY_INFORMATION_SUCCESS';
const GET_CENTER_GALLERY_INFORMATION_FAILURE = 'GET_CENTER_GALLERY_INFORMATION_FAILURE';
const GET_CHILD_GALLERY_REQUEST = 'GET_CHILD_GALLERY_REQUEST';
const GET_CHILD_GALLERY_SUCCESS = 'GET_CHILD_GALLERY_SUCCESS';
const GET_CHILD_GALLERY_FAILURE = 'GET_CHILD_GALLERY_FAILURE';
const APPROVE_PENDING_PHOTO_REQUEST = 'APPROVE_PENDING_PHOTO_REQUEST';
const APPROVE_PENDING_PHOTO_SUCCESS = 'APPROVE_PENDING_PHOTO_SUCCESS';
const APPROVE_PENDING_PHOTO_FAILURE = 'APPROVE_PENDING_PHOTO_FAILURE';
const REJECT_PENDING_PHOTO_REQUEST = 'REJECT_PENDING_PHOTO_REQUEST';
const REJECT_PENDING_PHOTO_SUCCESS = 'REJECT_PENDING_PHOTO_SUCCESS';
const REJECT_PENDING_PHOTO_FAILURE = 'REJECT_PENDING_PHOTO_FAILURE';
const DOWNLOAD_PHOTOS_REQUEST = 'DOWNLOAD_PHOTOS_REQUEST';
const DOWNLOAD_PHOTOS_SUCCESS = 'DOWNLOAD_PHOTOS_SUCCESS';
const DOWNLOAD_PHOTOS_FAILURE = 'DOWNLOAD_PHOTOS_FAILURE';

export default {
  GET_CENTER_GALLERY_INFORMATION_REQUEST,
  GET_CENTER_GALLERY_INFORMATION_SUCCESS,
  GET_CENTER_GALLERY_INFORMATION_FAILURE,
  GET_CHILD_GALLERY_REQUEST,
  GET_CHILD_GALLERY_SUCCESS,
  GET_CHILD_GALLERY_FAILURE,
  APPROVE_PENDING_PHOTO_REQUEST,
  APPROVE_PENDING_PHOTO_SUCCESS,
  APPROVE_PENDING_PHOTO_FAILURE,
  REJECT_PENDING_PHOTO_REQUEST,
  REJECT_PENDING_PHOTO_SUCCESS,
  REJECT_PENDING_PHOTO_FAILURE,
  DOWNLOAD_PHOTOS_REQUEST,
  DOWNLOAD_PHOTOS_SUCCESS,
  DOWNLOAD_PHOTOS_FAILURE
};
